import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "brand-icons-wrapper" }
const _hoisted_2 = { class: "layout-content-wrapper" }
const _hoisted_3 = { class: "footer" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://binovative.com",
  class: "text-white underline",
  target: "_blank"
}, "Binovative", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" & ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://startupcentrum.com",
  class: "text-white underline",
  target: "_blank"
}, "StartupCentrum", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(", Inc. All rights reserved.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_brand_icon = _resolveComponent("the-brand-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_brand_icon)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode("© " + _toDisplayString(new Date().getFullYear()) + " ", 1),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7
    ])
  ], 64))
}